import '../../types';
import { Placeholder } from '@tiptap/extensions';
export const DEFAULT_PLACEHOLDER_TEXT = 'Start typing here…';
export const EMPTY_EDITOR_CLASS = 'emptyEditor';
export const EMPTY_LINE_PLACEHOLDER = 'empty-line';
const isEditorEmpty = (editor) => {
    if (!editor.isEmpty) {
        return false;
    }
    const { doc } = editor.state;
    return doc.childCount <= 1;
};
export const createPlaceholderExtension = ({ mode, placeholderOptions, }) => {
    if (mode !== 'editor') {
        return null;
    }
    const config = {
        ...placeholderOptions,
    };
    config.emptyEditorClass = config.emptyEditorClass ?? EMPTY_EDITOR_CLASS;
    if (typeof placeholderOptions?.placeholder === 'function') {
        config.placeholder = placeholderOptions.placeholder;
    }
    else {
        const basePlaceholder = placeholderOptions?.placeholder ?? DEFAULT_PLACEHOLDER_TEXT;
        config.placeholder = ({ editor, node, }) => {
            if (isEditorEmpty(editor)) {
                return basePlaceholder;
            }
            if (editor.isFocused && node.type.name === 'paragraph' && node.content.size === 0) {
                return EMPTY_LINE_PLACEHOLDER;
            }
            return '';
        };
    }
    config.shouldShow =
        config.shouldShow ??
            (({ editor, node }) => {
                if (!editor.isEditable || node.type.name !== 'paragraph') {
                    return false;
                }
                if (node.content.size === 0) {
                    return isEditorEmpty(editor) || editor.isFocused;
                }
                return false;
            });
    return Placeholder.configure(config);
};
